export const MAX_MONTHLY_AD_BUDGET_MANWON = 200000;
export const MAX_MONTHLY_AD_BUDGET_KRW = 2_000_000_000;

export const formatKrwAsManwonInput = (value: string | number | null | undefined): string => {
	if (value === null || value === undefined || value === "") return "";

	const numericValue = String(value).replace(/[^\d]/g, "");
	if (numericValue === "") return "";

	const krw = Number(numericValue);
	if (!Number.isFinite(krw) || krw === 0) return "0";

	return Math.round(krw / 10000).toLocaleString();
};

export const convertManwonInputToKrw = (value: unknown): string => {
	const numericValue = String(value || "").replace(/[^\d,]/g, "");
	const numberOnly = numericValue.replace(/,/g, "");

	if (numberOnly === "") return "";
	if (/^0+$/.test(numberOnly)) return "0";

	const manwon = Number(numberOnly);
	if (!Number.isFinite(manwon)) return "";

	return (manwon * 10000).toLocaleString();
};
